import { useEffect, useRef, useState } from "react";
import { Frame } from "../../../types";
import FramesOptionsContent from "./frames-options-content";
import { useAuth } from "../../../global-components/src";
import { Pencil } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface FramesOptionsProps {
    frame?: Frame | null;
}

const FramesOptions: React.FC<FramesOptionsProps> = ({ frame }) => {
    const { t } = useTranslation();
    const closeModalRef = useRef<HTMLButtonElement | null>(null);
    const [open, setOpen] = useState(false);
    const { user, isSuper } = useAuth();
    const canAdmin = user?.permissions?.includes("create_frame") || isSuper();
    const navigate = useNavigate();


    useEffect(() => {
        const el = document.getElementById(`modal-frame-${frame?.id}`);
        if (!el) return;
        const onClose = () => setOpen(false);
        const onOpen  = () => setOpen(true);
        el.addEventListener("hidden.bs.modal", onClose);
        el.addEventListener("show.bs.modal", onOpen);
        return () => {
            el.removeEventListener("hidden.bs.modal", onClose);
            el.removeEventListener("show.bs.modal", onOpen);
        };
    }, [frame?.id]);

    return (
        <div
            className="modal fade"
            id={`modal-frame-${frame?.id}`}
            aria-hidden="true"
            style={{ zIndex: 17 }}
        >
            <div className="modal-dialog modal-dialog-centered foc-pc-dialog" role="document">
                <div className="modal-content foc-pc-modal-content">

                    {/* Header */}
                    <div className="foc-pc-header">
                        <h4 className="foc-pc-title">{frame?.name ?? t("frames.frame")}</h4>
                        <div className="d-flex" style={{ gap: 5 }}>
                            {canAdmin && (
                                <button type="button" className="foc-edit-btn" onClick={() => navigate(`/molduras/${frame?.id}`)} title={t("frames.editFrame")}>
                                    <Pencil size={15} />
                                </button>
                            )}
                            <button
                                ref={closeModalRef}
                                type="button"
                                className="foc-pc-close"
                                data-bs-dismiss="modal"
                                aria-label={t("frames.close")}
                            >
                                ✕
                            </button>
                        </div>
                    </div>

                    {/* Content */}
                    <FramesOptionsContent
                        open={open}
                        frame={frame}
                        onClose={() => closeModalRef.current?.click()}
                    />
                </div>
            </div>
        </div>
    );
};

export default FramesOptions;